export const NAME = "public/newPassword";
